import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AdPortalPage from "../pages/portal/page";
import ElitePortfolioPage from '../pages/elite-portfolio/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/portal",
    element: <AdPortalPage />,
  },
  {
    path: "/elite-portfolio",
    element: <ElitePortfolioPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
